var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F43E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_108158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_108158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22C9 21 9.21667 20.125 9.65 19.375C10.0833 18.625 10.65 18 11.35 17.5C12.05 17 12.85 16.625 13.75 16.375C14.65 16.125 15.5667 16 16.5 16C17.4333 16 18.35 16.125 19.25 16.375C20.15 16.625 20.95 17 21.65 17.5C22.35 18 22.9167 18.625 23.35 19.375C23.7833 20.125 24 21 24 22H9ZM26 30V22C26 20.0833 25.4125 18.4542 24.2375 17.1125C23.0625 15.7708 21.4083 14.8333 19.275 14.3L19 12H24V8H26V12H31L29.35 28.55C29.3 28.95 29.1208 29.2917 28.8125 29.575C28.5042 29.8583 28.1333 30 27.7 30H26ZM9 26V24H24V26H9ZM10 30C9.71667 30 9.47917 29.9042 9.2875 29.7125C9.09583 29.5208 9 29.2833 9 29V28H24V29C24 29.2833 23.9042 29.5208 23.7125 29.7125C23.5208 29.9042 23.2833 30 23 30H10Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome1);
export default __webpack_public_path__ + "static/media/outcome1.0efdfe386d92cbecdc5219ae67c4b3f0.svg";
export { ForwardRef as ReactComponent };